<template>
  <v-main class="pa-0">
    <div class="video-container">
      <video autoplay muted loop playsinline class="bg-video">
        <source src="/videos/bg-video.mp4" type="video/mp4" />
      </video>

      <div class="video-overlay"></div>

      <div
        class="text-container text-center text-white text-h4 d-flex flex-column align-center justify-center"
      >
        <h1
          class="shadow-text font-weight-black text-headline-small text-md-display-medium text-sm-display-small"
        >
          YAKINDA HİZMETİNİZDE
        </h1>
        <p class="text-title-large font-weight-light">
          Sizler için harika bir şeyler hazırlıyoruz.
        </p>
      </div>
    </div>
  </v-main>
</template>

<style scoped>
.video-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.bg-video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 0;
  transform: translate(-50%, -50%);
  object-fit: cover;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65); /* Karartma seviyesi */
  z-index: 1;
}

.shadow-text {
  letter-spacing: 4px !important;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
}
.text-container {
  z-index: 100;
  position: relative;
  height: 100vh;
  width: 100%;
}
</style>
